import { render, staticRenderFns } from "./MessageBubble.vue?vue&type=template&id=f03cc45c"
import script from "./MessageBubble.vue?vue&type=script&lang=js"
export * from "./MessageBubble.vue?vue&type=script&lang=js"
import style0 from "./MessageBubble.vue?vue&type=style&index=0&id=f03cc45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports